import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import Main from './components/Main';
import { ProviderAuth } from './components/providers/ProviderAuth';
import { useInitializeApp } from './useInitializeApp';

function App() {
  const sessionInitialized = useInitializeApp();

  return sessionInitialized ? (
    <ProviderAuth>
      <Router>
        <Main />
      </Router>
    </ProviderAuth>
  ) : (
    <div className="centered" id="initializingPane">
      <Spinner animation="border" />
      <br />
      Loading...
    </div>
  );
}

export default App;
